import { render, staticRenderFns } from "./OpenBoothChatButton.vue?vue&type=template&id=45eb3363&scoped=true&"
import script from "./OpenBoothChatButton.vue?vue&type=script&lang=js&"
export * from "./OpenBoothChatButton.vue?vue&type=script&lang=js&"
import style0 from "./OpenBoothChatButton.vue?vue&type=style&index=0&id=45eb3363&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eb3363",
  null
  
)

export default component.exports